var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m600 37.5c-104.39 0.09375-204.47 41.625-278.29 115.45s-115.36 173.9-115.45 278.29c0 266.21 363.84 705.94 379.36 724.5 3.5625 4.2656 8.8125 6.75 14.391 6.75s10.828-2.4844 14.391-6.75c15.516-18.562 379.36-458.29 379.36-724.5-0.09375-104.39-41.625-204.47-115.45-278.29s-173.9-115.36-278.29-115.45zm0 600c-54.703 0-107.16-21.75-145.82-60.422s-60.422-91.125-60.422-145.82c0-54.699 21.75-107.16 60.422-145.82 38.672-38.668 91.125-60.422 145.82-60.422s107.16 21.75 145.82 60.422c38.668 38.672 60.422 91.125 60.422 145.82-0.046875 54.703-21.797 107.11-60.469 145.78-38.672 38.672-91.078 60.422-145.78 60.469z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.64b3a9cd4decc7610061ba7d9ae12666.svg";
export { ForwardRef as ReactComponent };